import { render } from "./survey_prize.vue?vue&type=template&id=6fe80f33&scoped=true"
import script from "./survey_prize.vue?vue&type=script&lang=js"
export * from "./survey_prize.vue?vue&type=script&lang=js"

import "./survey_prize.vue?vue&type=style&index=0&id=6fe80f33&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe80f33"]])

export default __exports__